import { Link } from 'react-router-dom';

function PageTitle({ title, includeLinkBack, linkBackUrl, includeStatus }) {
  return (
    <div className='d-md-flex gap-md-4 gap-lg-5'>
      {includeLinkBack && (
        <div className='d-flex align-items-center mb-2 mb-md-0'>
          <Link to={linkBackUrl} className='text-reset text-decoration-none'>
            <span
              className='material-symbols-outlined'
              style={{ fontSize: '16px' }}
            >
              arrow_back_ios
            </span>
            <span>Tillbaka</span>
          </Link>
        </div>
      )}

      <div className='d-flex align-items-center gap-4 gap-md-4 gap-lg-5'>
        <h2 className='mb-0'>{title ? title : 'Namnlöst utkast'}</h2>
        {includeStatus}
      </div>
    </div>
  );
}

export default PageTitle;
